export enum MilestoneCategory {
  COUNT_BASED = "COUNT_BASED",
  PRICE_BASED = "PRICE_BASED",
}

export enum PROGRESS_BAR_TYPE {
  STATIC = "STATIC",
  DYNAMIC = "DYNAMIC",
}

// export enum MilestoneType {
//   FLAT_OFF = 'FLAT_OFF',
//   FREE_SHIPPING = 'FREE_SHIPPING',
//   FREEBIE = 'FREEBIE',
//   PERCENT_OFF = 'PERCENT_OFF'
// }

export const MILESTONE_TYPES = {
  FREEBIE: "FREEBIE",
  FREE_SHIPPING: "FREE_SHIPPING",
  PERCENT_OFF: "PERCENT_OFF",
  FLAT_OFF: "FLAT_OFF",
};

export type MilestoneBasis = "CART_PAYABLE_AFTER_DISCOUNT" | "MRP";

export type Milestone = {
  milestone: number;
  milestone_amount: number;
  milestone_header: string;
  milestone_text: string;
  milestone_type: (typeof MILESTONE_TYPES)[keyof typeof MILESTONE_TYPES];
};

export type ProgressBarType = {
  isEnabled: boolean;
  milestones: Milestone[];
  customizations: Customizations;
};

export interface Customizations {
  type: PROGRESS_BAR_TYPE;
  category: MilestoneCategory;
  completedMessage_enabled: boolean;
  completedMessage: string;
  // show header text before an offer is applicable
  textonProgressBar_header: boolean;
  textonProgressBar_headerColor: string;
  // show cart value for every milestone with progress bar
  textonProgressBar_amount: boolean;
  textonProgressBar_amountColor: string;
  // show milestone title for every offer
  textonProgressBar_title: boolean;
  textonProgressBar_titleColor: string;
  // progress bar color
  filledColor: string;
  backgroundColor: string;
  milestoneBasis?: MilestoneBasis;
}
